import { createStore, applyMiddleware } from "redux"
import rootReducer from "./reducers";
import Middlewarethunk  from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

const composedEnhancer = composeWithDevTools(applyMiddleware(Middlewarethunk))

const store = createStore(rootReducer(), composedEnhancer)
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
